import React from 'react';
import { frames } from '../../../../Styles';
import { useTranslation } from 'react-i18next';
import { Pages } from '../../../../Navigation/root';
import { PageHeader } from '../../../../Components';

export default function SilosSettings() {
  const {t} = useTranslation()
  
  return (
    <frames.Page_inner>
      <PageHeader topHeader={t(`menuHeaders.${Pages.silos}`, {defaultValue: "silos"})} subHeader={t(`menuHeaders.${Pages.silosSettings}`, {defaultValue: "silo settings"})}/>
    <frames._page_inner_content>
    </frames._page_inner_content>
    </frames.Page_inner>
  );
}